import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle4 from "../../randing/RandingStyle4";

function Randing156({ urlCode, urlCodeSettingId }) {
  const treatments = [
    { value: "678890f7-e05f-40e0-a901-62d94eca50ec", label: "교정)투명-100M" },
    { value: "3201dd9d-577b-4359-8528-db9dda0dad3f", label: "무삭제)평일25M" },
  ];
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/156/001.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/059/25010602.jpg`}
      benefitInfoPosition="top"
      formFieldColor="white"
      adTarget="맘카페 이용자"
      periodType="month"
      // privacyMessage="개인정보수집에 동의하시는 분만 '신청하기'버튼을 눌러주세요."
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/navy/applyBenefitButton.png`}
      companyName="본원"
      footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/geomdan2.jpg`}
      treatments={treatments}
      kakaotalk="003"
    />
  );
}

export default Randing156;
